import { Flex } from 'foundations-components/components/Flex';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * In-content layout switcher: an underlined tab strip to switch between the
 * portal instance's layouts. Colors come from the active theme to match the
 * branded content.
 */
export function LayoutTabs({
  layouts,
  activeLayoutKey,
  onSelect
}) {
  var _theme$color$fillPri;
  const theme = useTheme();
  const activeColor = theme.color['text-core-default'];
  const mutedColor = theme.color['text-core-subtle'];
  const indicatorColor = (_theme$color$fillPri = theme.color['fill-primary-default']) !== null && _theme$color$fillPri !== void 0 ? _theme$color$fillPri : activeColor;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    gap: "400",
    flexWrap: "wrap",
    "data-test-id": "page-builder-tabs",
    children: layouts.map(layout => {
      const isActive = layout.layoutKey === activeLayoutKey;
      const style = {
        font: 'inherit',
        fontWeight: 500,
        border: 'none',
        borderBlockEnd: `2px solid ${isActive ? indicatorColor : 'transparent'}`,
        background: 'transparent',
        color: isActive ? activeColor : mutedColor,
        padding: '6px 4px',
        cursor: onSelect && !isActive ? 'pointer' : 'default'
      };
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        "aria-current": isActive,
        disabled: !onSelect,
        onClick: onSelect && !isActive ? () => onSelect(layout.layoutKey) : undefined,
        style: style,
        children: layout.label || layout.layoutKey
      }, layout.layoutKey);
    })
  });
}